import { PdRatingStars } from "./PdRatingStars.js";
//#region src/pd-rating/pd-rating-stars.ts
var tag = "pd-rating-stars";
if (!customElements.get(tag)) customElements.define(tag, PdRatingStars);
//#endregion
export { PdRatingStars };
